<template>
  <div class="navbar">
    <div class="left-menu">
      <div
        class="menu-item menu-item__hamburger link"
        :class="sidebar.opened ? 'expand' : 'collapse'"
        :title="hamburgerTips"
        @click="toggleSideBar"
      >
        <svg-icon icon-class="hamburger" />
      </div>
      <div
        class="menu-item menu-item__refresh link"
        title="刷新"
        @click="handleRefresh"
      >
        <svg-icon icon-class="refresh" />
      </div>
      <!-- <el-link class="menu-item menu-item__store" href="/#/user/switch-store">
        门店：{{user_info.default_store_name || '--'}}
        <i class="el-icon-arrow-right" />
      </el-link> -->
    </div>

    <!-- <breadcrumb class="breadcrumb-container" /> -->

    <div class="right-menu">
      <span class="menu-item link" @click="logout">
        <svg-icon icon-class="logout" />
        退出
      </span>

      <span class="menu-item menu-item__user">
        <svg-icon icon-class="person" />
        {{ user_info.nickname }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Navbar",
  computed: {
    ...mapGetters(["sidebar", "avatar", "user_info"]),
    hamburgerTips() {
      return this.sidebar.opened ? "收起" : "展开";
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    handleRefresh() {
      window.location.reload();
    },
    logout() {
      this.$confirm("您确定要退出登录吗？")
        .then(() => this.$store.dispatch("user/logout"))
        .then(() => this.$router.push("/user/login"));
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: $navbarHeight;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  line-height: $navbarHeight;
  color: $color-text-primary;
  font-size: 14px;

  .left-menu,
  .right-menu {
    height: 100%;
    line-height: 50px;
    padding-left: 7px;

    .menu-item {
      display: inline-block;
      padding: 0 8px;

      .svg-icon {
        width: 20px;
        height: 20px;
        vertical-align: -5px;
        color: #8e8e8e;
      }

      &.link {
        cursor: pointer;
        &:hover {
          color: $color-primary;
          .svg-icon {
            color: $color-primary;
          }
        }
      }
    }
  }

  .left-menu {
    float: left;

    .menu-item__hamburger,
    .menu-item__refresh {
      line-height: 46px;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;
    }

    .menu-item__hamburger {
      &.collapse {
        .svg-icon {
          transform: rotate(180deg);
        }
      }

      .svg-icon {
        width: 18px;
        height: 18px;
      }
    }

    .menu-item__store {
      color: #303133;
      font-size: 15px;
      font-weight: 600;

      &:hover {
        color: $color-primary;
      }
    }
  }

  .right-menu {
    float: right;
    padding-right: 7px;

    .menu-item__user .svg-icon {
      width: 18px;
      height: 18px;
      vertical-align: -4px;
    }
  }
}
</style>
